import { Directive, effect, input, signal } from '@angular/core'

import { fonts, theme } from '@flowx/core-sdk'
import { DocumentPreviewStyles, applyDocumentPreviewCustomStyles } from '@flowx/core-theme'

@Directive({
  selector: 'flx-document-preview',
  host: {
    '[class]': 'styleClassName()',
  },
  standalone: true,
})
export class FlxDocumentPreviewStyleDirective {
  componentStyle = input<{
    style: DocumentPreviewStyles
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(async () => {
      const className = await applyDocumentPreviewCustomStyles(
        this.componentStyle().style,
        theme(),
        fonts()
      )
      this.styleClassName.set(className)
    })
  }
}
